// A scorpion, modelled facing +X: a flat segmented body, two pincers and a curled
// stinging tail arched over the back. Ported 1:1 from age-of-mcp's classic
// scorpion.ts, restoring its pincer loop, the tail-segment arc and the leg loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#5a3a1e",
      position: [0, 0.012, 0], scale: [1.6, 0.5, 1] },              // body
  ];
  // Pincers reaching forward.
  for (const z of [0.014, -0.014]) {
    parts.push(
      { geometry: new THREE.CylinderGeometry(0.003, 0.003, 0.022, 4), color: "#4a2e16",
        position: [0.024, 0.012, z], rotation: [0, 0, Math.PI / 2] },
      { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#6a4422",
        position: [0.04, 0.012, z] },
    );
  }
  // Tail — segments arcing up and over to a sting.
  const tail: Array<[number, number]> = [
    [-0.022, 0.016], [-0.034, 0.026], [-0.038, 0.04], [-0.03, 0.05],
  ];
  for (const [tx, ty] of tail) {
    parts.push({ geometry: new THREE.IcosahedronGeometry(0.006, 0),
      color: "#5a3a1e", position: [tx, ty, 0] });
  }
  parts.push({ geometry: new THREE.ConeGeometry(0.005, 0.014, 4), color: "#7a2a1a",
    position: [-0.02, 0.058, 0], rotation: [0, 0, 0.6] });          // sting
  // Legs.
  for (const side of [1, -1]) {
    for (let i = 0; i < 3; i++) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.0015, 0.0015, 0.018, 3),
        color: "#4a2e16", position: [(i - 1) * 0.01, 0.008, side * 0.018],
        rotation: [side * 0.9, 0, 0] });
    }
  }
  return parts;
}

export const scorpion = defineModel({
  id: "scorpion",
  batchId: "standard",
  name: "Scorpion",
  tags: ["creature","scorpion","low-poly","age-of-mcp","classic"],
  summary: "Low-poly scorpion.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  parts: () => partsFor(),
  animations: [],
});
